import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // baseURL: 'http://127.0.0.1:440/pharmaConnect/api/',
  baseURL: '/pharmaconnect-ws/',
  // baseURL: 'http://192.168.1.27/pharmaconnect-ws/',
  // baseURL: 'https://pharmaconnect.net/devpharma/',
  // baseURL: 'https://pharmaconnect.net/pharmaconnect/',
})

// export const DIRECTORY_FILES_PATH = "https://www.pharmaconnect.net/docserver/"
// export const DIRECTORY_FILES_PATH = "https://www.pharmaconnect.net/docserverdev/"
export const DIRECTORY_FILES_PATH = "/pharmaconnect-ws/docserver/"

Vue.prototype.$serverpath = DIRECTORY_FILES_PATH
Vue.prototype.$http = axiosIns
export default axiosIns